<template>
  <div id="industrial-map-page-container" class="full-height">
    <MapaIndustrialDinamico />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import MapaIndustrialDinamico from './movimentacoes-industriais/mapa-industrial-dinamico/MapaIndustrialDinamico.vue'

@Component({
  name: 'IndustrialMapPage',
  components: {
    MapaIndustrialDinamico
  }
})
class IndustrialMapPage extends Vue {
}
export default IndustrialMapPage
</script>

<style lang="stylus" scoped>
#industrial-map-page-container
  height: 100vh
  overflow: hidden
</style>
